import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CryptoHashService } from '../../service/common/crypto-hash.service';
import { SupervisorUpdate, Supervisor } from '../../entity';
import { NgForm } from '@angular/forms';
import { HotelService } from '../../service';

@Component({
    selector: 'app-hotel-details',
    templateUrl: './hotel-details.component.html'
})
export class HotelDetailsComponent implements OnInit {
    hotel: Supervisor;
    isEditable = false;

    constructor(
        private route: ActivatedRoute,
        private cryptoHashService: CryptoHashService,
        private hotelService: HotelService
    ) { }

    ngOnInit() {
        this.refresh();
    }

    refresh() {
        const hotel = new Supervisor();
        hotel.fromObject(this.route.snapshot.data['hotel']);

        this.hotel = hotel;
    }

    saveEditInfo(form: NgForm) {
        const update = new SupervisorUpdate(
            this.hotel.PortalOperatorID,
            this.hotel.CompanyID,
            this.hotel.PublicInstitutionID,
            this.hotel.Email,
            this.hotel.FirstName,
            this.hotel.LastName,
            this.getSupervisorPassword(),
            this.hotel.Phone,
        );

        this.hotelService.editHotel(update).subscribe(result => {
            if (result) {
                this.isEditable = false;
            }
        });
    }

    getSupervisorPassword(): string {
        let password = this.hotel.Password;

        if (this.hotel.NewPassword) {
            password = this.cryptoHashService.sha512(this.hotel.NewPassword, 512);
        }

        return password;
    }

    showEditable() {
        this.isEditable = true;
    }

    cancelEditable() {
        this.isEditable = false;
    }
}
